import { type CartDrawerItems } from '@/scripts/cart/cart-drawer-items'
import { type CartItems } from '@/scripts/cart/cart-items'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class CartSubscription extends UcoastEl {
	static htmlSelector = 'cart-subscription'

	subscription?: HTMLElement
	selectedSubscription?: HTMLElement
	sellingPlanCheckBox?: HTMLInputElement
	sellingPlans: NodeListOf<HTMLElement>

	constructor() {
		super()
		this.subscription = q.os<HTMLElement>('.subscription-content', this)
		this.selectedSubscription = q.os<HTMLElement>(
			'.subscription-label-selected',
			this
		)
		this.sellingPlanCheckBox = q.os<HTMLInputElement>('input', this)
		this.sellingPlans = this.querySelectorAll('[data-selling-plan-id]')

		this.sellingPlans.forEach((sellingPlan) => {
			sellingPlan.addEventListener('click', () => {
				this.selectPlan(sellingPlan)
			})
		})
	}

	selectPlan(sellingPlan: HTMLElement) {
		if (sellingPlan.classList.contains('active')) return

		const planId = sellingPlan.dataset.sellingPlanId ?? ''
		const planName = sellingPlan.textContent?.trim()
		const selectedLabel = this.selectedSubscription
			? q.os('span', this.selectedSubscription)
			: undefined
		if (selectedLabel && planName) selectedLabel.textContent = planName

		this.sellingPlans.forEach((plan) => {
			plan.classList.remove('active')
		})
		sellingPlan.classList.add('active')

		if (this.sellingPlanCheckBox) this.sellingPlanCheckBox.checked = false

		this.subscription?.classList.add('active')

		this.updateSellingPlan(planId)
	}

	updateSellingPlan(planId: string) {
		const line = this.dataset.line
		const quantity = this.dataset.quantity || '1'
		if (!line) {
			console.error('Missing line item line')
			return
		}

		const cartItems =
			q.oc<CartItems>(this, 'cart-items') ||
			q.rc<CartDrawerItems>(this, 'cart-drawer-items')
		cartItems.updateQuantity(line, quantity, undefined, planId)
	}
}
